import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const ImgsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  margin-bottom: 8px;
`

export const ImgWrapper = styled.div`
  display: flex;
  cursor: pointer;

  img {
    object-fit: contain;
  }
`

export const Title = styled.div`
  font-size: 16px;
  color: ${myPalette.midnightBlue.main};
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 24px;
`

export const Field = styled.div`
  font-size: 16px;
  color: ${myPalette.mutedText.main};
  margin-bottom: 8px;
  line-height: 24px;
`
